import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref, computed, watch } from 'vue';
import { VisuallyHidden } from 'radix-vue';
import CustomButton from '@/components/ui/CustomButton.vue';
import { Dialog, DialogHeader, DialogTitle, DialogDescription, DialogFooter, DialogClose } from '@/components/ui/dialog';
import CustomSelect from '@/components/ui/CustomSelect.vue';
import { store } from '@/plugins/store';
import { Barn } from '@/types';

// First step of Groups overview's create flow: which Section of this Barn to start a Production
// Group on. The rich fields (name, dates, pig-tally context) live in the shared
// ManageProductionGroupModal - this step exists only because Groups overview's "Create group"
// button is scoped to a Barn rather than to one Section already, unlike Active groups.

export default /*@__PURE__*/_defineComponent({
  __name: 'CreateGroupModal',
  props: /*@__PURE__*/_mergeModels({
    barn: {}
  }, {
    "modelValue": { type: Boolean },
    "modelModifiers": {},
  }),
  emits: /*@__PURE__*/_mergeModels(["chosen"], ["update:modelValue"]),
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;

const showModal = _useModel<boolean>(__props, 'modelValue');

const sectionId = ref<number | null>(null);
const sectionOptions = computed(() => store.state.sections?.filter((s) => s.barn_id === props.barn.barn_id) ?? []);

function handleContinue() {
    if (sectionId.value === null) {
        return;
    }

    emit('chosen', sectionId.value);
    showModal.value = false;
}

watch(showModal, (value) => {
    if (!value) {
        setTimeout(() => {
            sectionId.value = null;
        }, 300);
    }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Dialog), {
    modelValue: showModal.value,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((showModal).value = $event)),
    class: "sm:max-w-[420px]"
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(DialogHeader), null, {
        default: _withCtx(() => [
          _createVNode(_unref(DialogTitle), null, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('views.monitoring.groupOverview.modals.createGroup.title')), 1)
            ]),
            _: 1
          }),
          _createVNode(_unref(VisuallyHidden), null, {
            default: _withCtx(() => [
              _createVNode(_unref(DialogDescription), { class: "pt-4" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('views.monitoring.groupOverview.modals.createGroup.description')), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createElementVNode("form", {
        class: "mt-4",
        onSubmit: _withModifiers(handleContinue, ["prevent"])
      }, [
        _createVNode(CustomSelect, {
          value: sectionId.value,
          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((sectionId).value = $event)),
          items: sectionOptions.value,
          rules: [{ validate: (value) => value !== null, message: '' }],
          "item-text": "name",
          "item-value": "id",
          label: _ctx.$t('views.monitoring.groupOverview.modals.createGroup.fields.section'),
          required: "",
          "allow-empty": false
        }, null, 8, ["value", "items", "rules", "label"])
      ], 32),
      _createVNode(_unref(DialogFooter), { class: "mt-4" }, {
        default: _withCtx(() => [
          _createVNode(_unref(DialogClose), { "as-child": "" }, {
            default: _withCtx(() => [
              _createVNode(CustomButton, { "color-preset": "white" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('views.monitoring.groupOverview.modals.createGroup.buttons.cancel')), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(CustomButton, {
            disabled: sectionId.value === null,
            onClick: handleContinue
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('views.monitoring.groupOverview.modals.createGroup.buttons.continue')), 1)
            ]),
            _: 1
          }, 8, ["disabled"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})